export default __webpack_public_path__ + "static/media/btn_step_2_active.3ff81aaf.svg";